/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Dubbing_Export_Project_Video_LabelInputs */



/**
* | output |
* | --- |
* | "Project video:" |
*
* @param {Audio_Dubbing_Export_Project_Video_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_dubbing_export_project_video_label = /** @type {((inputs?: Audio_Dubbing_Export_Project_Video_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Dubbing_Export_Project_Video_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vidéo du projet :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektvideo:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video del progetto:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видео проекта:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Video del proyecto:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目视频：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのビデオ:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट वीडियो:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vídeo do projeto:")
	return /** @type {LocalizedString} */ ("Project video:")
});